export const COLORS = {
    $almostblack: "#1F1F1F",
    $slate: "#333333",
    $grey: "#6D6D6D",
    $stone: "#BABABA",
    $offwhite: "#F2F2F2",
    $white: "#FFFFFF"
};
